import { Pipe, PipeTransform, inject } from '@angular/core';
import { EnvService } from '@forgerock/backstage-ui-core';
import { SearchEnv } from '../model/search-env';

@Pipe({
  name: 'universityLearningPathUrl',
  pure: false,
  standalone: true
})
export class UniversityLearningPathUrlPipe implements PipeTransform {
  private envService = inject<EnvService<SearchEnv>>(EnvService);


  baseUrl: string;

  constructor() {
    this.envService.get()
      .then(({ trainingBaseUrl }) =>
        this.baseUrl = trainingBaseUrl
      )
      .catch(() => null);
  }

  transform(pathId: string): string {
    return this.baseUrl && pathId
      ? `${this.baseUrl}/on-demand/course/${encodeURIComponent(pathId)}`
      : null;
  }

}
